import { apiService } from './api';
import { MeasureUnit, MeasureUnitsResponse, CreateMeasureUnitRequest, UpdateMeasureUnitRequest } from '../types/ingredient';

class MeasureUnitService {
  // Dropdown (active only)
  async getMeasureUnits(): Promise<{ measureUnits: MeasureUnit[] }> {
    // For backward compatibility, keep this calling the list endpoint with limit and no search, but filter active client-side if needed.
    const res = await apiService.get<MeasureUnitsResponse>(`/measure-units?page=1&limit=1000`);
    return { measureUnits: res.measureUnits.filter(u => u.status === 'ACTIVE') };
  }

  // Paged list for the Setup page
  async list(params: { page: number; limit: number; search?: string; status?: 'ACTIVE' | 'INACTIVE'; sortBy?: string; sortOrder?: 'asc' | 'desc'; }): Promise<MeasureUnitsResponse> {
    const query = new URLSearchParams();
    query.set('page', String(params.page));
    query.set('limit', String(params.limit));
    if (params.search) query.set('search', params.search);
    if (params.status) query.set('status', params.status);
    if (params.sortBy) query.set('sortBy', params.sortBy);
    if (params.sortOrder) query.set('sortOrder', params.sortOrder);
    return apiService.get<MeasureUnitsResponse>(`/measure-units?${query.toString()}`);
  }

  async create(data: CreateMeasureUnitRequest): Promise<{ message: string; measureUnit: MeasureUnit }> {
    return apiService.post(`/measure-units`, data);
  }

  async update(id: string, data: UpdateMeasureUnitRequest): Promise<{ message: string; measureUnit: MeasureUnit }> {
    return apiService.put(`/measure-units/${id}`, data);
  }

  async delete(id: string): Promise<{ message: string }> {
    return apiService.delete(`/measure-units/${id}`);
  }

  async bulkUpdateStatus(ids: string[], status: 'ACTIVE' | 'INACTIVE'): Promise<{ success: boolean; message: string; count: number }> {
    return apiService.post(`/measure-units/bulk-status`, { ids, status });
  }

  async exportMeasureUnits(params?: { search?: string; status?: 'ACTIVE' | 'INACTIVE'; ids?: string[] }): Promise<Blob> {
    const baseURL = process.env.REACT_APP_API_URL || '/api';
    const query = new URLSearchParams();
    if (params?.search) query.set('search', params.search);
    if (params?.status) query.set('status', params.status);
    if (params?.ids && params.ids.length) query.set('ids', params.ids.join(','));
    const response = await fetch(`${baseURL}/measure-units/export?${query.toString()}`, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    });
    if (!response.ok) throw new Error('Export failed');
    return response.blob();
  }
}

export const measureUnitService = new MeasureUnitService();
